import React from 'react';
import { useDispatch } from 'react-redux';
import { PayPalButtons, PayPalScriptProvider } from '@paypal/react-paypal-js';
import { showSuccess, storePaypalInstantPayment } from 'store/slices';
import { encrypt } from 'utils/helpers';

const initialOptions = {
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_SECRET,
  currency: 'USD',
  intent: 'capture',
};

const PayPalPayment = ({ data, setSuccessStatus }) => {
  const dispatch = useDispatch();

  const { amount, currency, reference_id, abstract_id } = data;

  const purchaseUnits = [
    {
      amount: {
        value: amount,
        currency_code: currency,
      },
      reference_id: reference_id,
      custom_id: abstract_id,
    },
  ];

  return (
    <PayPalScriptProvider options={initialOptions}>
      <PayPalButtons
        style={{ layout: 'horizontal', shape: 'pill', height: 40, width: 60 }}
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: purchaseUnits,
          });
        }}
        onApprove={async (data, actions) => {
          try {
            const details = await actions.order.capture();
            const updatedDetails = {
              ...details,
              abstract_id: abstract_id,
            };
            const payload = {
              paypalPaymentData: encrypt(updatedDetails),
            };
            const response = await dispatch(storePaypalInstantPayment(payload));

            if (response?.data?.status === 'COMPLETED') {
              dispatch(showSuccess('Payment Successful'));
              setSuccessStatus(true);
            } else {
              setSuccessStatus(false);
              dispatch(showSuccess('Payment Failed'));
            }
          } catch (error) {
            console.error('Error capturing order:', error);
          }
        }}
        onCancel={() => {
          console.log('Payment cancelled');
        }}
        onError={(err) => {
          console.error('PayPal error:', err);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalPayment;
